export const removeHtmlTags = (val: string): string =>
  val.replace(/(<[^>]+>)/gim, '');
